module.exports = __webpack_public_path__ + "img/oil-power-plant.10161297.webp";